module.exports = (__parcel__import__("6nOCg")).then(() => parcelRequire('fyWP3'));